/**
 * Task BB: work photos for POS sales (walk-ins) grouped Today / Yesterday by the branch day.
 * (Task DD removed the after-checkout prompt + its setting, and the Google Maps key path.)
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  // Photos page (store app)
  ["bb.ph.today", "Today", "今天"],
  ["bb.ph.yesterday", "Yesterday", "昨天"],
  ["bb.ph.none", "No customers today or yesterday yet. Appointments and checked-out sales with your services show here.", "今天和昨天还没有顾客。您做过服务的预约和已结账的订单会显示在这里。"],
  ["bb.ph.noneAll", "No appointments or sales with services today or yesterday.", "今天和昨天没有预约或含服务的订单。"],
  ["bb.ph.walkIn", "Walk-in sale", "到店消费"],
  ["bb.ph.anon", "Walk-in (no customer on the sale)", "散客（订单未登记顾客）"],
  ["bb.ph.anonHint", "This sale has no customer. Add the customer to the sale at the counter, then upload the photos.", "该订单未登记顾客。请先在收银处为订单添加顾客，再上传作品照。"],
  ["bb.ph.photos", "{n} photos", "{n} 张照片"],
  ["bb.ph.forSale", "Sale {label}", "订单 {label}"],
] as const;

export type BbKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<BbKey, string>;

export const taskBB = { en: col(1), zh: col(2), ms: col(1) };
